import styled from 'styled-components';
import Country from '../../../components/fields/CountryField';
import { type Brightness } from '../../context';
import { PorscheSelectCss } from './shared';
import withPorscheSelect from './withPorscheSelect';

const PorscheCountryField = styled(Country)<Brightness>`
    ${PorscheSelectCss}
`;

const CountryField = withPorscheSelect(PorscheCountryField);
export default CountryField;
